import { render, staticRenderFns } from "./NavigationDrawerStudents.vue?vue&type=template&id=3f8ec5ed&scoped=true"
import script from "./NavigationDrawerStudents.vue?vue&type=script&lang=js"
export * from "./NavigationDrawerStudents.vue?vue&type=script&lang=js"
import style0 from "./NavigationDrawerStudents.vue?vue&type=style&index=0&id=3f8ec5ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8ec5ed",
  null
  
)

export default component.exports